import { Helmet } from "react-helmet-async";

const SITE_NAME = "Calm Coast Hypnotherapy";
const SITE_URL = "https://www.calmcoasthypnotherapy.co.uk";
const DEFAULT_DESCRIPTION =
  "Solution focused hypnotherapy in Wembury and online for anxiety, stress, burnout, sleep and confidence.";
const DEFAULT_IMAGE_PATH = "/android-chrome-512x512.png";
const DEFAULT_KEYWORDS = [
  "solution focused hypnotherapy",
  "hypnotherapy Wembury",
  "hypnotherapy Plymouth",
  "hypnotherapy South Devon",
  "hypnotherapy Devon",
  "hypnotherapy South Hams",
  "anxiety support",
  "stress support",
  "burnout support",
  "online hypnotherapy"
].join(", ");

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  imagePath = DEFAULT_IMAGE_PATH,
  noIndex = false,
  keywords = DEFAULT_KEYWORDS
}) {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonicalPath = path.startsWith("/") ? path : `/${path}`;
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;
  const imageUrl = `${SITE_URL}${imagePath}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
}
